var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'custom-file': true,
  'invalid': _vm.isInvalid
}},[_c('input',{ref:"input",staticClass:"custom-file-input",attrs:{"type":"file","id":_vm.id,"aria-describedby":_vm.id,"multiple":_vm.multiple,"disabled":_vm.disabled},on:{"change":function($event){_vm.index !== false ? _vm.onChange($event, _vm.index) : _vm.onChange($event)}}}),_c('label',{staticClass:"custom-file-label",attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }